<template>
  <div
    class="col-sm-12 col-md-12 col-lg-12 pr0"
    v-if="
      previousOrderPizza.length > 0 && !separateMenuVariant && reOrderVariant
    "
  >
    <div
      class="d-flex justify-content-between align-items-center previous-order-header pTB16 pr16"
    >
      <div class="main-header">
        <span class="fs-18 bold"> Quick Order </span>
      </div>
      <div class="bold color-secondary" @click="viewAllHandler()">
        View All Orders
      </div>
    </div>
    <div class="reorder-carousel mb16">
      <Carousel :items-to-show="1.5" :transition="500">
        <Slide v-for="(offer, ind) in previousOrderPizza" :key="ind">
          <div class="pizza-items mr5">
            <div class="pizza-header plr12">
              <span class="bold fs-14">{{
                dateCoversionFun(offer?.orderTimeStamp)
              }}</span>
              <button class="plr4 bold color-secondary fs-10 ptb1 previous-btn">
                PREVIOUS ORDER
              </button>
            </div>
            <div class="main-pizza-body">
              <ol class="pizza-body">
                <li
                  class="list-dec plr12"
                  v-for="(item, index) in reOrderDisplayFun(offer.items) || []"
                  :key="index"
                >
                  <div class="fs-12 tag-veg-icon tl" v-if="!(index >= 4)">
                    <i
                      class="mr5"
                      :class="[
                        {
                          'tag-veg': item.product.foodType === 'VEG',
                        },
                        {
                          'tag-non-veg': item.product.foodType === 'NON_VEG',
                        },
                        {
                          disabled: checkCurrentItemPresentOrNot(item?.product),
                        },
                      ]"
                    ></i>
                    <span
                      class="lh18 three-dot"
                      :class="[
                        checkCurrentItemPresentOrNot(item?.product) &&
                          'disabled',
                      ]"
                    >
                      <span v-if="item.product">{{ item.product.name }}</span>
                      <span v-if="item.size">| {{ item.size.name }}</span>
                      <span v-if="item.crust">| {{ item.crust.name }}</span>
                    </span>
                    <div
                      class="pl5 pr"
                      v-if="checkCurrentItemPresentOrNot(item?.product)"
                    >
                      <!-- <i class="fs-14 jfi-info-line"></i> -->
                      <reusable-tooltip
                        :helper-class="'black-toolTip tip-bottom arrow-top-right slide-bottom'"
                      >
                        <template v-slot:helpmsg>
                          <p class="lh18">
                            We are sorry! This item is currently not available
                            on the selected store
                          </p>
                        </template>
                      </reusable-tooltip>
                    </div>
                    <!-- <i class="pl5 toolTip tip-top" v-if="checkCurrentItemPresentOrNot(item?.product)">+</i> -->
                  </div>
                  <div
                    class="prev-order-cust"
                    v-if="!(index >= 4)"
                    :class="[
                      checkCurrentItemPresentOrNot(item?.product) && 'disabled',
                    ]"
                  >
                    <div
                      v-if="
                        convertAllToppingIntoSingleString(item.addTopngs || [])
                          .length > 37
                      "
                      class="fs-11 topping-item-data lh16"
                    >
                      <div class="added-color-with-ellipsis">
                        Added:
                        {{
                          convertAllToppingIntoSingleString(
                            item.addTopngs || []
                          )
                        }}
                      </div>
                      <span
                        v-if="
                          Number(
                            addedCount(
                              convertAllToppingIntoSingleString(
                                item.addTopngs || []
                              )
                            )
                          ) > 0
                        "
                      >
                        {{
                          "+" +
                          addedCount(
                            convertAllToppingIntoSingleString(
                              item.addTopngs || []
                            )
                          )
                        }}
                      </span>
                    </div>
                    <div v-else class="fs-11 added-color lh16">
                      <div
                        v-if="item.addTopngs !== undefined"
                        class="three-dot"
                      >
                        Added:
                        {{
                          convertAllToppingIntoSingleString(
                            item.addTopngs || []
                          )
                        }}
                      </div>
                    </div>
                  </div>
                </li>
                <hr v-if="itemCount(offer.items)" class="ml0 mr0" />
              </ol>
              <do-you-know
                v-if="itemCount(offer.items)"
                :itemSize="(offer.items || []).length"
              ></do-you-know>
              <div
                v-if="offer?.items?.length > 4"
                class="bold color-secondary fs-12 col-sm-12 tl mb5 ro-more-item"
              >
                +{{ offer?.items?.length > 4 ? offer?.items.length - 4 : "" }}
                items
              </div>
            </div>
            <div class="pizza-footer plr12">
              <span class="fs-14"
                ><span>{{ currencySymbol }}</span>{{ offer?.netPrice || "" }} |
                {{
                  Math.round(totalReOrderCount(offer?.items)) ||
                  offers?.items?.length ||
                  ""
                }}
                items</span
              >
              <div class="button-group">
                <!-- <button // hide for temporary bcz it is in next sprint
                  class="line-btn dark sm mr10"
                  @click="editPreviousOrder(offer)"
                >
                  Edit
                </button> -->
                <button
                  class="bold"
                  :class="[
                    'btn',
                    checkReorderButtonDisable(offer.items) && 'disabled',
                  ]"
                  @click="addAllOrderIntoCart(offer.items, false, ind)"
                >
                  Reorder
                </button>
              </div>
            </div>
          </div>
        </Slide>
        <template #addons> </template>
      </Carousel>
    </div>

    <generic-modal
      v-if="showEditPreviousOrderModal"
      @close="closeModal($event)"
      :height="msModalDim.height"
      :width="msModalDim.width"
      :animationStyle="msModalDim.animationStyle"
      :padding="msModalDim.padding"
      :modalClass="msModalDim.modalClass"
    >
      <template v-slot:header>
        <!-- <p class="modal-title fs-18 lh25 bold mb20 ml10">Sort by</p>
        <i @click="closeModal($event)" class="jfi-cross sticky-pop-cross"></i> -->
        <div
          class="d-flex justify-content-between align-items-center previous-order-header pTB16 plr16"
        >
          <div class="main-header">
            <span @click="closeModal(true, getPreviousOrder?.currentCartData)">
              <i class="jfi-back-v2 fs-14"></i>
            </span>
            <span class="fs-18 bold ml19"> Quick Order </span>
          </div>
          <div class="bold color-secondary" @click="viewAllHandler()">
            View All Orders
          </div>
        </div>
        <div
          class="pt12 plr16 previous-order-status d-flex justify-content-between align-items-center"
        >
          <span class="fs-12 color-base bold">
            {{ getPreviousOrder?.orderTime || "" }}
          </span>
          <span>
            <span>{{ currencySymbol }}</span>{{ getPreviousOrder?.netPrice || "" }} |
            <span>{{ getPreviousOrder?.totalItems || "" }} items</span>
          </span>
        </div>
      </template>
      <template v-slot:body>
        <div
          class="pb16 pt8 plr16 reorder-edit-modal-body"
          v-if="getPreviousOrder.currentCartData.length > 0"
        >
          <div
            v-for="(data, ind) in getPreviousOrder.currentCartData || []"
            :key="ind"
          >
            <quick-order-items :propsData="data"></quick-order-items>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div
          class="d-flex justify-content-center align-items-center previous-order-footer pTB16 plr16"
        >
          <button
            class="fs-14 btn w100 bold"
            @click="addAllOrderIntoCart(getPreviousOrder.currentCartData, true)"
          >
            <span v-if="Number(cartQuantity) !== 0"
              ><i>{{ currencySymbol }}</i>{{ Number(cartQuantity) }} |
            </span>
            Add all
          </button>
        </div>
        <div></div>
      </template>
    </generic-modal>
  </div>
</template>

<script>
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide } from "vue3-carousel";
import LocalStorageFunc from "../helpers/localStorageFunc";
import {
  keyMapsGetter,
  keyMapsAction,
  keyMapsMutation,
} from "../helpers/storeKeys";
import GenericModal from "./GenericModal.vue";
import utility from "../helpers/utility.js";
import { v2PwaBasePath } from "../config/apiEndpoints";
import setEvents from "../helpers/events";
import ReusableTooltip from "./ReusableTooltip.vue";
import userActivityTracking from "../helpers/UserActivityTracking";
import PageNames from "../config/pageNames";
import { defineAsyncComponent } from "vue";
import {
  VWO_NEXTGEN_HOMEPAGE_EXPERIMENT,
  VWO_NEXTGEN_EXPERIMENT_VARIANTS,
} from "../config/vwoKeys";
import { CURRENCY_SYMBOL } from "../helpers/paymentConstants";

export default {
  name: "ReOrder",
  components: {
    Carousel,
    Slide,
    DoYouKnow: defineAsyncComponent(() => import("./DoYouKnow.vue")),
    GenericModal,
    QuickOrderItems: defineAsyncComponent(() =>
      import("./QuickOrderItems.vue")
    ),
    ReusableTooltip,
  },
  data() {
    return {
      allSetting: [],
      showEditPreviousOrderModal: false,
      msModalDim: {
        width: "100vw",
        height: "100vh",
        animationStyle: "full-screen-popup",
        modalClass: "re-order-modal",
        padding: "0px",
      },
      isImpressionProcessed: false,
      pizzaCat: ["PIZ"],
      nonPizzaCat: {
        SIDES: ["BRD", "NVPARCEL", "TACNV", "VGP"],
        BEVRAGES: ["BEV", "CMB", "CAKE", "DST", "SID", "DIP"],
      },
      currencySymbol: CURRENCY_SYMBOL,
    };
  },
  mounted() {},
  watch: {
    reOrderVariant(newVal, oldVal) {
      if (newVal) {
        LocalStorageFunc.isLoggedIn() &&
          this.$store.dispatch(keyMapsAction.GET_REORDER_DATA, {
           newApi : false,
           apiControl : false
          }); //false for old api
      }
    },
  },
  updated() {
    if (!this.isImpressionProcessed && this.previousOrderPizza.length > 0) {
      if (
        this.previousOrderPizza[0]?.items &&
        this.previousOrderPizza[0].items.length > 0
      ) {
        this.eventFunction(false, {}, this.previousOrderPizza[0].items);
        this.isImpressionProcessed = true;
      }
    }
  },
  methods: {
    getOrderItemArray(itemArr) {
      let itemList = [];
      for (let i = 0; i < itemArr.length; i++) {
        itemList.push(
          itemArr[i].product
            ? itemArr[i].product.name?.toLowerCase()
            : itemArr[i]?.name?.toLowerCase()
        );
      }
      return itemList;
    },
    eventFunction(isClicked = false, eObj = {}, itemArr = []) {
      let eventType = isClicked ? "Click" : "Impression";
      let userAction = isClicked ? "click" : "impression";

      let preEventObj = { category: this.getOrderItemArray(itemArr), ...eObj };

      const eventObj = utility.amplitudeEventObj(
        userAction,
        "quick order",
        "5",
        preEventObj
      );
      setEvents("amplitude", eventType, eventObj);
    },

    eventFunctionForAddToCart(item, index) {
      let initialCartUpdatedByUserActionRef = {
        type: "ADD",
        item: item,
        sectionName: "quick order",
        sectionPosition: "5",
        positionWithinSection: index,
      };
      let preEventObj = {
        eventCategory: "ecommerce",
        eventAction:
          initialCartUpdatedByUserActionRef.type == "REMOVE"
            ? "remove from cart"
            : "add to cart",
        addToCartQuantity:
          initialCartUpdatedByUserActionRef.type == "REMOVE" ? -1 : 1,
        itemName:
          initialCartUpdatedByUserActionRef.item?.product?.name?.toLowerCase(),
        price: initialCartUpdatedByUserActionRef.item?.pricePerQty,
        itemSku: initialCartUpdatedByUserActionRef.item?.product?.id,
        isIrctcOrder: "no",
        size: initialCartUpdatedByUserActionRef.item?.size?.name?.toLowerCase(),
        crust:
          initialCartUpdatedByUserActionRef.item?.crust?.name?.toLowerCase(),
        ecomCategory:
          initialCartUpdatedByUserActionRef.item?.product?.name?.toLowerCase(),
        positionWithinSection:
          initialCartUpdatedByUserActionRef.positionWithinSection,
      };

      if (initialCartUpdatedByUserActionRef.source == "searchModal") {
        if (
          initialCartUpdatedByUserActionRef.subSource ==
          "nonCustomizableCardAdd"
        ) {
          preEventObj["screenName"] =
            PageNames.NEXTGEN_SEARCH_NON_CUSTOMISATIONPAGE;
          preEventObj["previousScreenname"] = PageNames.NEXTGEN_SEARCHPAGE;
        } else if (
          initialCartUpdatedByUserActionRef.subSource == "customisation"
        ) {
          preEventObj["screenName"] =
            PageNames.NEXTGEN_SEARCH_CUSTOMISATIONPAGE;
          preEventObj["previousScreenname"] = PageNames.NEXTGEN_SEARCHPAGE;
        } else {
          preEventObj["screenName"] = PageNames.NEXTGEN_SEARCHPAGE;
          preEventObj["previousScreenname"] = PageNames.NEXTGEN_HOMEPAGE;
        }
      } else {
        if (
          initialCartUpdatedByUserActionRef.subSource ==
          "nonCustomizableCardAdd"
        ) {
          preEventObj["screenName"] = PageNames.NEXTGEN_NON_CUSTOMISATIONPAGE;
          preEventObj["previousScreenname"] = PageNames.NEXTGEN_HOMEPAGE;
        } else if (
          initialCartUpdatedByUserActionRef.subSource == "customisation"
        ) {
          preEventObj["screenName"] = PageNames.NEXTGEN_CUSTOISATIONPAGE;
          preEventObj["previousScreenname"] = PageNames.NEXTGEN_HOMEPAGE;
        }
      }

      preEventObj["sectionPosition"] =
        initialCartUpdatedByUserActionRef.sectionPosition;

      if (initialCartUpdatedByUserActionRef.sectionName) {
        preEventObj["sectionName"] =
          initialCartUpdatedByUserActionRef.sectionName;
      }

      let eventType = "addToCart";
      let sectionPosition = preEventObj["sectionPosition"];
      delete preEventObj["sectionPosition"];
      const eventObj = utility.amplitudeEventObj(
        "click",
        preEventObj["screenName"] == PageNames.NEXTGEN_SEARCHPAGE
          ? "search"
          : preEventObj["sectionName"]
          ? preEventObj["sectionName"]
          : "bottom menu",
        sectionPosition,
        preEventObj
      );
      setEvents("amplitude", eventType, eventObj);
    },

    itemCount(data) {
      //  show the Do you know UI if item's count is less than 3
      let doYouKnowShow = false;
      if (data?.length >= 3 && data?.length !== undefined) {
        doYouKnowShow = false;
      } else {
        doYouKnowShow = true;
      }
      return doYouKnowShow;
    },
    addedCount(data) {
      // topping's count function
      let count = 0;
      let items = data.split(",");
      if (items.length > 4) {
        count = items.length - 4;
      } else {
        count = 0;
      }
      return count;
    },
    convertAllToppingIntoSingleString(data) {
      //  mapping all the topping items name
      let toppngArry = data.map((i) => i.name);
      return [...new Set(toppngArry)].join();
    },
    checkReorderItemIsAvailInCurrentStore(currentItem, preArry) {
      const { sizeCode, code } = currentItem;
      let allSizeCode = preArry.map((i) => {
        if (
          i.product.sizeCode !== "." &&
          i.product.sizeCode !== undefined &&
          i.product.sizeCode
        ) {
          return i.product.sizeCode || "";
        }
      });
      let allMenuCode = preArry.map((i) => {
        if (
          i.product.menuCode !== "." &&
          i.product.menuCode !== undefined &&
          i.product.menuCode
        ) {
          return i.product.menuCode || "";
        }
      });
      if (this.pizzaCat.includes(String(code.slice(0, 3)))) {
        // only when the category is type PIZZ [ menuCode is the identifier]
        if (allMenuCode.some((j) => j == code)) {
          return true;
        } else {
          return false;
        }
      } else {
        if (this.nonPizzaCat.BEVRAGES.includes(String(code.slice(0, 3)))) {
          // this is only when category is not pizza but it can be some bevarages  [ menuCode is the identifier]
          if (allMenuCode.some((j) => j == code)) {
            return true;
          } else {
            return false;
          }
        } else {
          if (allSizeCode.some((l) => l == sizeCode)) {
            //  when it is not pizza not a bevarages [ sizeCode and menuCode is the Identifier]
            if (allMenuCode.some((j) => j == code)) {
              return true;
            }
          } else {
            return false;
          }
        }
      }
    },
    getItemData(data) {
      // find the obj which is matched according to menuCode and sizeCode
      let ary = [];
      if (data !== undefined) {
        ary = this.getProductItemsInOneArray.filter((i) => {
          if (this.checkReorderItemIsAvailInCurrentStore(i, data)) {
            let qu = data?.find((k) => k.product.menuCode === i.code)?.quantity;
            if (i["sortOrder"]) {
              delete i["sortOrder"];
            }
            if (i["customCategoryId"]) {
              delete i["customCategoryId"]; //  for remove duplicay while edit the previous order data
            }
            if (i["customCategoryName"]) {
              delete i["customCategoryName"]; //  for remove duplicay while edit the previous order data
            }
            if (qu) {
              i["quantity"] = qu;
            }
            return i;
          }
        });
      }
      return utility.sortQniqueArry(ary);
    },
    passDataIntoCart(item) {
      // passed the selected items data into reOrder store
      utility.sortQniqueArry(this.getItemData(item)).forEach((i) => {
        this.setEditPreviousDataIntoStore({ ...i, quantity: 1 }); // it will push the current selected obj
      });
      this.displayDataInModal(this.getItemData(utility.sortQniqueArry(item)));
    },
    addAllOrderIntoCart(item, isModalOpen, ind = 0) {
      //amplitude addtoCart event
      item?.forEach((element) => {
        let elementQuantity = element?.quantity || 1;
        for (var i = 0; i < elementQuantity; i++) {
          this.eventFunctionForAddToCart(element, ind + 1);
        }
      });

      // add the all the previous order items into cart
      userActivityTracking.reorder(0);
      if (isModalOpen) {
        this.getPreviousOrder.currentCartData.forEach((i) => {
          this.$store.commit(keyMapsMutation.PREVIOUS_ORDER_ADD_TO_CART, i);
        });
        this.closeModal();
        this.eventFunction(
          true,
          {
            subCategory: "reorder",
            addToCart: 1,
          },
          item
        );
      } else {
        utility.sortQniqueArry(this.getItemData(item)).forEach((i) => {
          this.$store.commit(keyMapsMutation.PREVIOUS_ORDER_ADD_TO_CART, i);
        });
        this.eventFunction(
          true,
          {
            subCategory: "reorder",
            addToCart: 1,
          },
          item
        );
      }
      utility.sendToNextGenCart();
    },
    setEditPreviousDataIntoStore(data) {
      this.$store.commit(keyMapsMutation.ADD_PREVIOUS_ORDER_DATA, data);
    },
    editPreviousOrder(data) {
      let obj = {};
      obj["netPrice"] = data?.netPrice || "";
      obj["totalItems"] = data?.items.length || "";
      obj["orderTime"] = this.dateCoversionFun(data?.orderTimeStamp);
      this.passDataIntoCart(utility.sortQniqueArry(data?.items) || []); // set the cartItems data into editPreviousOrderData
      this.$store.commit(keyMapsMutation.UPDATE_CURRENT_ITEM_DETAILS, obj);
      this.triggerModal();
    },
    triggerModal(e) {
      document.body.classList.add("body-stop-scroll-mobile");
      this.showEditPreviousOrderModal = true;
    },
    closeModal(backButton = false, itemArr = []) {
      this.$store.commit(keyMapsMutation.RESET_CART_ITEM_DATA); // reset the data while close the currentCartData
      this.$store.commit(keyMapsMutation.RESET_CURRENT_ITEM_DETAILS);
      document.body.classList.remove("body-stop-scroll-mobile");
      this.showEditPreviousOrderModal = false;
    },
    dateCoversionFun(data) {
      // convert date into readable date
      let date = String(new Date(data)).split(" ");
      return `Ordered on ${
        date[2] + utility.findOrdinalsSufixInDate(date[2])
      } ${date[1]} ${date[3]}`;
    },
    addQuuantityKey(data) {
      let str = [];
      data.forEach((k) => {
        str.push({ ...k, quantity: 1 });
      });
      return str;
    },
    displayDataInModal(data) {
      if (data?.length > 0 && this.cartItemData.length > 0) {
        let arr = utility.deepCopyArry(
          this.cartItemData.filter((i) => data.map((j) => j.id).includes(i.id))
        );
        this.$store.commit(
          keyMapsMutation.UPDATE_AND_CHECK_CURRENT,
          utility.sortQniqueArry(arr)
        );
        // return this.cartItemData.filter(i => this.getPreviousOrder.currentCartData.map(j => j.id).includes(i.id))
      } else if (data?.length > 0 && this.cartItemData?.length === undefined) {
        let obj = utility.sortQniqueArry(this.getProductItemsInOneArray);
        let arr1 = obj.filter((i) => data.map((j) => j.id).includes(i.id));
        this.$store.commit(
          keyMapsMutation.UPDATE_AND_CHECK_CURRENT,
          utility.deepCopyArry(this.addQuuantityKey(arr1))
        );
      }
    },
    viewAllHandler() {
      // for all reorders history
      this.eventFunction(
        true,
        {
          subCategory: "view all orders",
        },
        this.getPreviousOrder?.currentCartData
      );
      window.location.href = `${v2PwaBasePath}/orderHistory`;
    },
    reOrderDisplayFun(data) {
      // when we have more than 4 items in order so we have to slice to display less
      const finalDisplayData = data?.length > 4 ? data.slice(0, 4) : data;

      finalDisplayData.forEach((item) => {
        if (item.product?.foodType === "VEG" && item.addTopngs?.some((topng) => topng?.foodType === "NON_VEG")) {
          item.product.foodType = "NON_VEG";
        }
      });

      return finalDisplayData;
    },
    totalReOrderCount(data) {
      return (
        data
          .reduce((acc, cartItem) => {
            return cartItem.quantity + acc;
          }, 0)
          .toFixed(2) || 0
      );
    },
    checkCurrentItemPresentOrNot(data) {
      // for identify the item is present in reorder data or not
      if (this.getProductItemsInOneArray && data) {
        return utility.getNotAvailablePizzaInStore(
          this.getProductItemsInOneArray,
          data
        );
      }
    },
    checkReorderButtonDisable(data) {
      // for disable the button if there are no items present in current store
      let isAva = [];
      if (data && this.getProductItemsInOneArray?.length !== undefined) {
        isAva = this.getProductItemsInOneArray.find((o) => {
          let allSizeCode = data.map((i) => {
            if (
              i.product.sizeCode !== "." &&
              i.product.sizeCode !== undefined &&
              i.product.sizeCode
            ) {
              return i.product.sizeCode || "";
            }
          });
          let allMenuCode = data.map((i) => {
            if (
              i.product.menuCode !== "." &&
              i.product.menuCode !== undefined &&
              i.product.menuCode
            ) {
              return i.product.menuCode || "";
            }
          });
          if (this.pizzaCat.includes(String(o.code.slice(0, 3)))) {
            // only when the category is type PIZZ [ menuCode is the identifier]
            if (allMenuCode.some((j) => j == o.code)) {
              return true;
            } else {
              return false;
            }
          } else {
            if (
              this.nonPizzaCat.BEVRAGES.includes(String(o.code.slice(0, 3)))
            ) {
              // this is only when category is not pizza with some bevarages  [ menuCode is the identifier]
              if (allMenuCode.some((j) => j == o.code)) {
                return true;
              } else {
                return false;
              }
            } else {
              if (allSizeCode.some((l) => l == o.sizeCode)) {
                if (allMenuCode.some((j) => j == o.code)) {
                  return true;
                }
              } else {
                return false;
              }
            }
          }
        });
      }
      if (isAva && Object.keys(isAva)?.length > 0) {
        return false;
      } else {
        return true;
      }
    },
  },
  computed: {
    reOrderPizza() {
      return this.$store.state.ReOrder.reOrderData;
    },
    previousOrderPizza() {
      if (!this.reOrderVariant) return [];
      return this.$store.state.ReOrder.previousOrderData;
    },
    productItemsData() {
      return this.$store.state.ProductItems.productItems;
    },
    cartItemData() {
      return this.$store.state.Cart.cartItems;
    },
    getProductItemsInOneArray() {
      return this.$store.getters[keyMapsGetter.GET_PRODUCT_ITEMS_IN_ONE_ARRAY];
    },
    getPreviousOrder() {
      return this.$store.state.ReOrder.editPreviousOrderData;
    },
    cartQuantity() {
      return this.$store.getters[keyMapsGetter.CURRENT_CART_TOTAL];
    },
    isLoggedIn() {
      return this.$store.state.Auth.isLoggedIn;
    },
    separateMenuVariant() {
      let exp = this.$store.state.Config.vwoExperiments;
      if (
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_U
      ) {
        return true;
      } else {
        return false;
      }
    },
    reOrderVariant() {
      let flag = window._siteProps_?.props?.shouldShowReorderItemWise;
      let exp = this.$store.state.Config.vwoExperiments;
      if (
        flag === "true" &&
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] &&
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_Z &&
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] !==
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_ZA
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped></style>
